import * as React from "react";
import { EditNotesMenuItem } from "./EditNotesMenuItem.tsx";
import { Doc } from "@repo/convex/convex/_generated/dataModel";
import { DropdownMenu } from "@radix-ui/themes";
import { ExternalLinkIcon, ReaderIcon } from "@radix-ui/react-icons";
import { ItemDetailsMenuItem } from "./ItemDetailsMenuItem.tsx";
import { CopyLinkMenuItem } from "./CopyLinkMenuItem.tsx";
import { ItemChatMenuItem } from "./ItemChatMenuItem.tsx";
import { routes } from "../../../routing/router.ts";

interface Props {
  item: Doc<"items">;
}

export const CommonMenuItems: React.FC<Props> = ({ item }) => {
  return (
    <>
      <DropdownMenu.Item onClick={() => routes.item({ itemId: item._id }).push()}>
        <ReaderIcon />
        Read it here
      </DropdownMenu.Item>
      <DropdownMenu.Item onClick={() => window.open(item.url, "_blank", "noopener")}>
        <ExternalLinkIcon />
        Open the original
      </DropdownMenu.Item>
      <CopyLinkMenuItem itemUrl={item.url} />
      <DropdownMenu.Separator />
      <EditNotesMenuItem itemId={item._id} />
      <ItemChatMenuItem itemId={item._id} />
      <ItemDetailsMenuItem itemId={item._id} />
      <DropdownMenu.Separator />
    </>
  );
};
